import React from 'react'
import { useNavigate } from "react-router-dom";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { useState } from 'react';
import { useMemo } from 'react';

function Company() {

    const navigate = useNavigate();
    const handleEdit = (workload) => {
        navigate(`/provider/work-order/edit`, { state: { draft: workload.workorderedit } });
    };

    const [rowData, setRowData] = useState([
        {
            CompanyName: "Company 1",

            Status: "",

            StartDate: "Jan 6, 2024",

            EndDate: "Jan 6, 2024",

            Modules: "",

            Actions: "",
        },

        {
            CompanyName: "Company 2",

            Status: "",

            StartDate: "Jan 6, 2024",

            EndDate: "Jan 6, 2024",

            Modules: "",

            Actions: "",
        },

        {
            CompanyName: "Company 3",

            Status: "",

            StartDate: "Jan 6, 2024",

            EndDate: "Jan 6, 2024",

            Modules: "",

            Actions: "",
        },

        {
            CompanyName: "Company 4",

            Status: "",

            StartDate: "Jan 5, 2024",

            EndDate: "Jan 5, 2024",

            Modules: "",

            Actions: "",
        },

        {
            CompanyName: "Company 5",

            Status: "",

            StartDate: "Jan 5, 2024",

            EndDate: "Jan 5, 2024",

            Modules: "",

            Actions: "",
        },

        {
            CompanyName: "Company 6",

            Status: "",

            StartDate: "Jan 5, 2024",

            EndDate: "Jan 5, 2024",

            Modules: "",

            Actions: "",
        },

        {
            CompanyName: "Company 7",

            Status: "",

            StartDate: "Jan 4, 2024",

            EndDate: "Jan 4, 2024",

            Modules: "",

            Actions: "",
        },

        {
            CompanyName: "Company 7",

            Status: "",

            StartDate: "Jan 3, 2024",

            EndDate: "Jan 3, 2024",

            Modules: "",

            Actions: "",
        },



    ]);

    const [colDefs, setColDefs] = useState([
        {
            headerCheckboxSelection: true, // Checkbox in the header for selecting/deselecting all rows
            checkboxSelection: true, // Checkbox in each cell
            width: 50,
        },
        { field: "CompanyName", filter: true, headerName: " Company Name" },
        {
            field: "Status",
            headerName: "Status",
            cellRenderer: (param) => {
                return (
                    <>
                        <div className='div-MPPwiusxtE'>
                            <button type="button" data-bs-toggle="button" className='btn d-flex align-items-center gap-2'><span className='span-SyGxjMnKNq'></span><span>Active</span></button>
                        </div>
                    </>
                );
            },
            filter: false,
        },
        { field: "StartDate", filter: true, headerName: "Start Date" },
        { field: "EndDate", filter: true, headerName: "End Date" },
        {
            field: "Modules",
            headerName: "Modules",
            width: "400",
            cellRenderer: (param) => {
                return (
                    <>
                        <div className='div-WZWR4m5wwn'>
                            <button type="button" data-bs-toggle="button" className='btn'>Module 1: Level 1</button>
                            <button type="button" data-bs-toggle="button" className='btn'>Module 2: Level 1</button>
                            <button type="button" data-bs-toggle="button" className='btn btn-aBx49CkXe9'>+4</button>
                        </div>
                        
                    </>
                );
            },
            filter: false,
        },
        {
            field: "Actions",
            headerName: "Actions",
            cellRenderer: (param) => {
                return (
                    <>
                        <div className='div-WZWR4m5wwn'>
                            <button type="button" data-bs-toggle="button" className='btn' style={{color: "#535862"}}><i class="fa-solid fa-trash"></i></button>
                            <button type="button" data-bs-toggle="button" className='btn'><i class="fa-solid fa-pen-to-square"></i></button>
                        </div>
                        
                    </>
                );
            },
            filter: false,
        },


    ]);
    const defaultColDef = useMemo(() => {
        return {
            width: 200,
            sortable: true,
        };
    }, []);

    const [paginationPageSize, setPaginationPageSize] = useState(20);


    return (
        <>
            <div id='main-company' className='container'>
                <div className="row">
                    <div className="col-12 mb-3">
                        <div className='div-5FmRwlvOhJ'>
                            <h1 className='fw-bold'>Company </h1>
                            <button className='btn btn-danger rounded-5' style={{ backgroundColor: "#28912F" }}>Add Company</button>
                        </div>
                    </div>

                    <div className="col-12">
                        <div
                            className="ag-theme-quartz"
                            style={{
                                width: "100%",
                            }}
                        >
                            <AgGridReact
                                rowData={rowData}
                                columnDefs={colDefs}
                                defaultColDef={defaultColDef}
                                pagination={true}
                                paginationPageSize={paginationPageSize}
                                domLayout="autoHeight" // Automatically adjusts grid height based on content
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Company